export enum ReportType {
  users = 'users',
  opps = 'opps',
  surveys = 'surveys',
  users_email_subscription = 'users_email_subscription'
}